import React from "react";
import UploadIcon from "@assets/images/NoSubscriptionAstronot.png";
import { useTranslation } from "react-i18next";
const URL_TO_NAVIGATE = process.env.REACT_APP_WORDPRESS_URL;
const NoHistory = ({
  quizHistory = false,
  completed = true,
  topPlayers = false,
}) => {
  const { t } = useTranslation();
  const messages = {
    completed: {
      heading: t("mindfulnessCoachPreferences.No Completed Practices"),
      subheading: t(
        "mindfulnessCoachPreferences.You haven’t completed any practices yet. Keep going!"
      ),
    },
    notCompleted: {
      heading: t("mindfulnessCoachPreferences.No Pending Practices"),
      subheading: t(
        "mindfulnessCoachPreferences.Great job! You don’t have any pending practices."
      ),
    },
    quizHistory: {
      heading: "No Quiz History",
      subheading: "You haven’t completed any quizes yet. Keep going!",
    },
    noPlayers: {
      heading: "No Players Yet",
      subheading: "Results will be displayed here when players participate.",
    },
  };
  return (
    <div
      className={`p-10 bg-white rounded-[12px] flex flex-col justify-center items-center`}
    >
      <img
        src={UploadIcon}
        className={`border-[1px] border-solid border-white rounded-[50%] p-1 ${
          (quizHistory || topPlayers)&& "w-[100px]"
        }`}
        alt={"Upload icon"}
      />
      <h2 className="text-[24px] font-[700] text-[#303030] text-center font-Lato">
        {topPlayers
          ? messages.noPlayers.heading
          : quizHistory
          ? messages.quizHistory?.heading
          : completed
          ? messages.completed.heading
          : messages.notCompleted.heading}
      </h2>
      <p className="text-[#6C6C6C] text-[16px] font-[Lato] text-center my-2 max-w-[80%]">
        {topPlayers
          ? messages.noPlayers.subheading
          : quizHistory
          ? messages.quizHistory?.subheading
          : completed
          ? messages.completed.subheading
          : messages.notCompleted.subheading}
      </p>
    </div>
  );
};

export default NoHistory;
